import { render, staticRenderFns } from "./ItemsFilter.vue?vue&type=template&id=0ed994d5"
import script from "./ItemsFilter.vue?vue&type=script&lang=js"
export * from "./ItemsFilter.vue?vue&type=script&lang=js"
import style0 from "./ItemsFilter.vue?vue&type=style&index=0&id=0ed994d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports